//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        name: 'task-info',
        props: {
            task: {
                type: Object,
                default: null,
            },
            type: {
                type: String,
                default: '',
            }
        },
        data: function () {
            return {
                currentTask: {

                }
            }
        },
        watch: {
            task (val) {
                this.currentTask = val;
            }
        },
        mounted(){
            //console.log(this.task);
            if (this.task != null && this.task != '') {
                this.currentTask = this.task
                //console.log(this.type);
            }
        },
        methods: {
            handleClick () {
                this.$emit('t-click', this.currentTask);
            }
        },
        computed: {
            //判断已办任务的提交日期和申请日期
            checkType () {
               
                if (this.type === "已办任务") {
                    return this.currentTask.submitDate;
                } else {
                    return this.currentTask.applicationDate;
                }
            },
            //判断已办任务的提交日期和申请日期
            checkApplicationDate () {
                if (this.type === "已办任务") {
                    return "提交日期：";
                } else {
                    return "申请日期：";
                }
            },
            //判断已办任务的签约日期和审批通过日期
            checkApprovalTitle () {

                if (this.type === "已办任务") {
                    return "签约日期：";
                } else {
                    return "审批通过日期：";
                }
            },
            //判断已办任务的签约日期和审批通过日期
            checkApprovalDate () {
                if (this.type === "已办任务") {
                    return this.currentTask.contractDate;
                } else {
                    return this.currentTask.approvalDate;
                }
            }
        }
        
    }



// WEBPACK FOOTER //
// ./src/components/TaskInfo.vue